import * as _ from 'lodash';
import { forkJoin } from 'rxjs/observable/forkJoin';

import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService, AlertService, DateUtils } from 'ng-jhipster';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';


// ag grid
import {GridOptions} from '@ag-grid-community/all-modules';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import {CsvExportModule} from '@ag-grid-community/csv-export';

import { Account, DateUtilities, LoginModalService, Principal } from '../shared';
import { Student } from '../entities/student';
import { LessonService, Lesson} from '../entities/lesson';
import { TranslateService } from 'ng2-translate';
import { School, SchoolService } from '../entities/school';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'lessons-by-instructor-report',
    templateUrl: './lessons-by-instructor-report-component.html'
})
export class LessonsByInstructorReportComponent implements OnInit {
    account: Account;
    modalRef: NgbModalRef;
    student: Student;
    isLoading: boolean;
    lessons: Lesson[];
    currentSchool: School;
    currentSearchByDateFrom: NgbDateStruct;
    currentSearchByDateTo: NgbDateStruct;
    noRowsTemplate = '<span>Pas de cours dans les dates choisies, choisissez des nouvelles dates et cliquez sur chercher</span>';


    public rowData: any[];
    private columnDefs: any[];
    private defaultColDef;
    public modules: any[] = [ClientSideRowModelModule, CsvExportModule];
    private gridApi;
    private gridColumnApi;

    constructor(
        private alertService: AlertService,
        private jhiLanguageService: JhiLanguageService,
        private principal: Principal,
        private lessonService: LessonService,
        private translateService: TranslateService,
        private dateFormatter: NgbDateParserFormatter,
        private dateUtils: DateUtils
    ) {
        this.jhiLanguageService.setLocations(['lessons-by-instructor-report']);
    }

    ngOnInit() {
        this.isLoading = false;
        this.defaultColDef = {
            editable: true,
            resizable: true,
            minWidth: 100,
            flex: 1,
         };

        this.loadHeaders();
        this.rowData = [];

        this.principal.identity().then((account) => {
            this.account = account;
        });
    }

    private loadHeaders() {
        // initialize the headers with the configured language
        forkJoin(
            this.translateService.get('jYoguiApp.lessons-by-instructor-report.grid.email'),
            this.translateService.get('jYoguiApp.lessons-by-instructor-report.grid.name'),
            this.translateService.get('jYoguiApp.lessons-by-instructor-report.grid.lastName'),
            this.translateService.get('jYoguiApp.lessons-by-instructor-report.grid.date'),
            this.translateService.get('jYoguiApp.lessons-by-instructor-report.grid.type'),
            this.translateService.get('jYoguiApp.lessons-by-instructor-report.grid.location'),
            this.translateService.get('jYoguiApp.lessons-by-instructor-report.grid.status'),
            this.translateService.get('jYoguiApp.lessons-by-instructor-report.grid.isOnline'),
            this.translateService.get('jYoguiApp.lessons-by-instructor-report.grid.isFree'),
            this.translateService.get('jYoguiApp.lessons-by-instructor-report.grid.bookings'),
            this.translateService.get('jYoguiApp.lessons-by-instructor-report.grid.availablePlaces')
        ).subscribe((response: Response[]) => {
           this.columnDefs = [
               {headerName: response[0], field: 'email', sortable: true, filter: true, sort: 'desc'},
               {headerName: response[1], field: 'name', sortable: true, filter: true},
               {headerName: response[2], field: 'lastName', sortable: true, filter: true},
               {headerName: response[3], field: 'date', sortable: true, filter: true},
               {headerName: response[4], field: 'type', sortable: true, filter: true},
               {headerName: response[5], field: 'location', sortable: true, filter: true},
               {headerName: response[6], field: 'status', sortable: true, filter: true},
               {headerName: response[7], field: 'isOnline', sortable: true, filter: true},
               {headerName: response[8], field: 'isFree', sortable: true, filter: true},
               {headerName: response[9], field: 'bookings', sortable: true, filter: true},
               {headerName: response[10], field: 'availablePlaces', sortable: true, filter: true}
           ];
        });
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onBtnExport() {
        this.gridApi.exportDataAsCsv({
            suppressQuotes: true,
            columnSeparator: ';'
        });
    }

    isSearchValid() {
        return DateUtilities.isDateRangeValid(this.currentSearchByDateFrom, this.currentSearchByDateTo, false);
    }

    private  search() {
        if (!this.isSearchValid()) {
            return;
        }
        this.loadHeaders();
        this.isLoading = true;
        this.lessonService.search({
            page: 0,
            query: DateUtilities.getDateRangeQuery('begining', this.currentSearchByDateFrom, this.currentSearchByDateTo),
            size: 5000,
        }).subscribe(
            (res: HttpResponse<Lesson[]>) => this.onSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    private onSuccess(data, headers) {
        this.lessons = data;
        this.rowData = [];
        let teacherEmail: string;
        let teacherName: string;
        let teacherLastName: string;

        this.lessons.forEach(l => {
            if (l.teacher) {
                teacherEmail = l.teacher.user.email;
                teacherName = l.teacher.user.firstName;
                teacherLastName = l.teacher.user.lastName;
            } else {
                teacherEmail = '';
                teacherName = '';
                teacherLastName = '';
            }

            // we convert the dates from the server
            let lessonsBegining = this.dateUtils.convertDateTimeFromServer(l.begining);
            this.rowData.push({
                email : teacherEmail,
                name : teacherName,
                lastName : teacherLastName,
                date: this.dateFormatter
                .format({
                    day : lessonsBegining.getDate(),
                    month: lessonsBegining.getMonth() + 1,
                    year: lessonsBegining.getFullYear()
                }),
                type: l.classType.name,
                location : l.location.name,
                status: l.status,
                isOnline: l.videoConference,
                isFree: l.free,
                bookings : l.bookings,
                availablePlaces : l.availablePlaces
            });
        });
        this.isLoading = false;
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/lessons-by-instructor-report/lessons-by-instructor-report.component.ts